import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryMonthlyChangeReport'
import Component from 'components/Reports/InventoryMonthlyChangeReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryMonthlyChangeReport })(Component)
